import script from "./BarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./BarChart.vue?vue&type=script&lang=ts&setup=true"

import "./BarChart.vue?vue&type=style&index=0&id=d3b8de62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b8de62"]])

export default __exports__